import React, {useState} from 'react';
// import Loader from '@components/framework/loader/Loader';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextareaAutosize
} from '@material-ui/core';
import {useSnackbar} from 'notistack';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {useSelector} from 'react-redux';
import {State} from '@shared/store/reducers/Index';
import {useTranslation} from 'react-i18next';
import {IgnoreClaim} from '@shared/services/VaccinesServicesClaims';
import {formatApiMessage} from '@shared/utils/formatApiMessage';
interface NotesProps {
  open: boolean;
  claimId: number;
  onClose?: (response: string) => void;
  title?: string;
}
const IgnoreDialog = (props: NotesProps): React.ReactElement => {
  const {
    open,
    claimId,
    // isLoading,
    onClose
  } = props;
  const [notes, setNotes] = useState('');
  const groupId: any = useSelector((state: State) => state.auth.groupId);
  const selectedClinicId: any = useSelector(
    (state: State) => state.clinics.selectedClinicId || []
  );
  const {enqueueSnackbar} = useSnackbar();
  const {t} = useTranslation();
  const handleClose = React.useCallback(
    (response: 'confirm' | 'cancel') => {
      if (typeof onClose === 'function') {
        onClose(response);
      }
    },
    [onClose]
  );
  const renderNotesTextArea = () => {
    return (
      <TextareaAutosize
        className="app-text-area"
        value={notes}
        onChange={event => {
          setNotes(event?.target?.value);
        }}
        rowsMax={10}
        rows={4}
        aria-label="maximum height"
      />
    );
  };

  // consent form Review API Integration
  const updateTheClaim = async () => {
    if (!notes.trim()) {
      enqueueSnackbar(t('Reason is required'), SnackBarConfig('e'));
      return;
    }
    try {
      const payload: any = {
        reason: notes
      };
      const response = await IgnoreClaim(
        groupId,
        selectedClinicId?.[0],
        claimId,
        payload
      );
      if (response) {
        handleClose('confirm');
        enqueueSnackbar(
          formatApiMessage(response?.message ?? response),
          SnackBarConfig('s')
        );
      }
    } catch (error: unknown) {
      enqueueSnackbar(formatApiMessage(error), SnackBarConfig('e'));
    }
  };

  // **FIXME: need to render the HTML content inside the dialog content here **/
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth={'sm'}
      fullWidth={true}
      open={open}
      onClose={handleClose}>
      <DialogTitle disableTypography>{t('Ignore Claim')}</DialogTitle>
      <DialogContent dividers>
        <div>{t('Reason')}*</div>
        {renderNotesTextArea()}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose('cancel')}>
          {t('APPOINTMENTS.CLOSE_BUTTON')}
        </Button>
        <Button
          onClick={() => updateTheClaim()}
          color="primary"
          variant={'contained'}>
          {t('APPOINTMENTS.SUBMIT_BUTTON')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IgnoreDialog;
